import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ModalModel } from '@libs/common/models';
import { DialogService } from '@libs/shared/common';
import { Subscription } from 'rxjs';
import { ModalPanelComponent } from './panel/modal-panel.component';

@Component({
  selector: 'ui-modal',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
  ],
})
export class ModalComponent implements OnChanges, OnDestroy {
  private readonly dialogService: DialogService = inject(DialogService);

  private dialog?: MatDialogRef<unknown>;
  private subscription?: Subscription;

  @Input() public isOpen: boolean = false;
  @Input() public data!: ModalModel;
  @Output() public dialogResult: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('dialog') public dialogTemplateRef!: TemplateRef<unknown>;

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.dialog || changes['isOpen']?.currentValue !== true) {
      return;
    }

    this.dialog = this.dialogService.open(ModalPanelComponent, { data: this.data });
    this.subscription = this.dialog.afterClosed().subscribe(
      this.afterClosed.bind(this),
    );
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.dialog?.close();
  }

  private afterClosed(result: string): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.subscription!.unsubscribe();
    this.isOpen = false;
    this.dialog = undefined;
    this.dialogResult.emit(result);
  }
}
